module.exports = __webpack_public_path__ + "static/media/8OLA11.90c9d0b6.jpg";